export class ProjectService {
    constructor(params) {
        if(params.apiUrl === null || params.apiUrl === undefined) {

        }

        this.apiUrl = params.apiUrl;

        console.log(this.apiUrl);
    }

    getProjects(userId) {
        return fetch(`${this.apiUrl}/projects?userId=${userId}`).then(response => {
            if (response.status !== 200) throw Error("Error");
            
            return response.json();
        }).catch(error => {
            console.error(error);
        });
    }

    getProjectById(projectId, userId) {
        return fetch(`${this.apiUrl}/projects?userId=${userId}&projectId=${projectId}`).then(response => {
            if (response.status !== 200) throw Error("Error");
            
            return response.json();
        }).catch(error => {
            console.error(error);
        });
    }

    deleteProject(projectId, userId) {
        // Default options are marked with *
        return fetch(`${this.apiUrl}/projects/${projectId}?userId=${userId}`, {
            // body: JSON.stringify(params), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, same-origin, *omit
            headers: {
            'user-agent': 'Mozilla/4.0 MDN Example',
            'content-type': 'application/json'
            },
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then(response => response.json()) // parses response to JSON
    }

    postProject(project, userId) {
        let params = {
            project: {
                name: "..."
            },
            user: {
                id: userId
            }
        };

        // Default options are marked with *
        return fetch(`${this.apiUrl}/projects/`, {
            body: JSON.stringify(params), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, same-origin, *omit
            headers: {
            'user-agent': 'Mozilla/4.0 MDN Example',
            'content-type': 'application/json'
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then(response => response.json()) // parses response to JSON
    }

    putProject(project, userId) {
        let params = {
            project: project,
            user: {
                id: userId
            }
        };

        console.log(project);

        console.log(params);

        // Default options are marked with *
        return fetch(`${this.apiUrl}/projects/`, {
            body: JSON.stringify(params), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, same-origin, *omit
            headers: {
            'user-agent': 'Mozilla/4.0 MDN Example',
            'content-type': 'application/json'
            },
            method: 'PUT', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then(response => response.json()) // parses response to JSON
    }

}


// WEBPACK FOOTER //
// src/services/project.service.js